<form id="self-information" [formGroup]="regForm" (ngSubmit)="step5Submitted(regForm)" novalidate>


  
  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">{{'Step5-Credentials.TranslationSection.text1' | translate}}</label>
  
  </div><br><br>
  
  <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Credentials').invalid">
    ***section required (please select position)***
  </div><br>
  <div class="form-row">


    <div class="form-group col-lg-6 col-sm-6 col-md-6" >
      <label>{{'Step5-Credentials.TranslationSection.text2' | translate}}
      </label>&nbsp;
  
  
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="HHA_YES"  (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text3' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="HHA_NO"  (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text4' | translate}}</label>
      </div>     
    </div>
  
  </div>
  


  <div class="form-row">

    <div class="form-group col-lg-6 col-sm-6 col-md-6" >
      <label>{{'Step5-Credentials.TranslationSection.text5' | translate}}
      </label>&nbsp;
    
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="PCA_YES"  (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text6' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="PCA_NO"  (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text7' | translate}}</label>
      </div>     
    </div>
    </div>
    
    
 
    
    
    <div class="form-row">
    
    <div class="form-group col-lg-7 col-sm-7 col-md-7" >
    
      <label>{{'Step5-Credentials.TranslationSection.text8' | translate}}
      </label>&nbsp;
    
    
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="Companion_YES"  (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text9' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="Companion_NO"  (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text10' | translate}}</label>
      </div>     
    </div>
    </div>


    <div class="form-row">
    
    
      <div class="form-group col-lg-6 col-sm-6 col-md-6" >
        <label>{{'Step5-Credentials.TranslationSection.text11' | translate}}
        </label>&nbsp;
      
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="CNA_YES"  (click)="toggleCredentialsClick('Yes')">
            <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text12' | translate}}</label>
        </div>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="CNA_NO"  (click)="toggleCredentialsClick('No')">
            <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text13' | translate}}</label>
        </div>     
      </div>
      </div>
    
    
    <div class="form-row">
    
    <div class="form-group col-lg-6 col-sm-6 col-md-6" >
      <label>{{'Step5-Credentials.TranslationSection.text14' | translate}}
      </label>&nbsp;
    
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="RN_YES" (click)="toggleCredentialsClick('Yes')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text15' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="RN_NO" (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text16' | translate}}</label>
      </div>     
    </div>
    </div>
    
    
    <div class="form-row">
    
    <div class="form-group col-lg-6 col-sm-6 col-md-6" >
      <label>{{'Step5-Credentials.TranslationSection.text17' | translate}}
      </label>&nbsp;
    
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="LPN_YES" (click)="toggleCredentialsClick('Yes')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text18' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="LPN_NO" (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text19' | translate}}</label>
      </div>     
    </div>
    </div>
    
    
    <div class="form-row">
    
    <div class="form-group col-lg-6 col-sm-6 col-md-6" >
      <label>{{'Step5-Credentials.TranslationSection.text20' | translate}}
      </label>&nbsp;
    
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="NP_YES"  (click)="toggleCredentialsClick('Yes')" >
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text21' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="credentials" formControlName="Credentials" value="NP_NO"   (click)="toggleCredentialsClick('No')">
          <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text22' | translate}}</label>
      </div>     
    </div>
    </div>







<div class="form-row">

<div class="form-group col-lg-4 col-sm-4 col-md-4" >
  <label>{{'Step5-Credentials.TranslationSection.text23' | translate}}</label>
  <select id="Hhlicstate" class="form-control" for="Hhlicstate" formControlName="Hhlicstate" [ngClass]="{'form-submitted': isSubmitted}">
    <option [selected]="1==1">{{'Step5-Credentials.TranslationSection.text24' | translate}}</option>
    <option *ngFor="let state of states" [ngValue]="state.abbreviation">{{state.name}}</option>
  </select>
</div>


<div class="form-group col-lg-2 col-sm-2 col-md-2 " >
  <label>{{'Step5-Credentials.TranslationSection.text25' | translate}}</label> &nbsp;
  <input type="text" class="form-control" for="Hhlicno"  formControlName="Hhlicno" id="Hhlicno" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
   
</div>

<div class="form-group col-lg-6 col-sm-6 col-md-6" >
  <label>{{'Step5-Credentials.TranslationSection.text26' | translate}}</label>&nbsp;
  <input type="date" class="form-control" for="Hhlicexp"  formControlName="Hhlicexp" id="Hhlicexp" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
</div>
</div>




<div class="form-row">
<div class="form-group col-lg-6 col-sm-6 col-md-6" >
  <label>{{'Step5-Credentials.TranslationSection.text27' | translate}}

  </label>

</div>
<div class="form-group col-lg-5 col-sm-5 col-md-5" >

  <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio"  id="Proins" formControlName="Proins" value="Yes" >
      <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text28' | translate}}</label>
  </div>
  <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio"  id="Proins" formControlName="Proins" value="No" >
      <label class="form-check-label" for="yes">{{'Step5-Credentials.TranslationSection.text29' | translate}}</label>
  </div>     

  <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Proins').invalid">
    ***required field***
  </div>
</div>


</div>




  <br/>

<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step5-Credentials.TranslationSection.text30' | translate}}</button>
  &nbsp;
  <button type="submit"  class="btn btn-primary" >{{'Step5-Credentials.TranslationSection.text31' | translate}} &nbsp;
    <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   


<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step5-Credentials.TranslationSection.text32' | translate}}</i>

  
</form>